<template>
	<div>
        <FormulateForm v-model="form4">
            <br>
            <FormulateInput name="id" type="identity_document" label="Passport"></FormulateInput>
            <FormulateInput name="id2" type="identity_document" label="testr"></FormulateInput>
        </FormulateForm>
		<FormulateForm
			:schema="schema"
			v-model="form3"
			@submit="submit"
			@submit-raw="submit"
		/>
		<FormulateForm>
			<br>
			<FormulateInput type="stars" label="stars" required></FormulateInput>
			<br>
			<FormulateInput type="submit" label="test"></FormulateInput>
		</FormulateForm>
		<hr>
		<FormulateForm v-model="form">
			<br>
			<FormulateInput type="birthday" label="Birthday"></FormulateInput>
			<br>
			<FormulateInput type="countrydropdown" label="country"></FormulateInput>
			<br>
			<FormulateInput type="viewtext" label="Test" value="123"></FormulateInput>
			<hr>
			<FormulateInput type="checkbox" label="test-label"></FormulateInput>
			<hr>
			<FormulateInput type="signature" label="test-label"></FormulateInput>
			<hr>
			<FormulateInput type="checkbox" label="test-label with value" value="test-value"></FormulateInput>
			<hr>
			<FormulateInput type="checkbox" label="test-label" :options="{one: 'One', two: 'Two'}"></FormulateInput>
			<hr>
			<FormulateInput type="switchbox" label="test-label"></FormulateInput>
			<hr>
			<FormulateInput type="switchbox" label="test-label" :options="{one: 'One', two: 'Two'}"></FormulateInput>
			<hr>
			<FormulateInput type="radio" label="test-label"></FormulateInput>
			<hr>
			<FormulateInput type="radio" label="test-label" :options="{one: 'One', two: 'Two'}"></FormulateInput>
			<hr>
			<FormulateInput type="switchradio" label="test-label"></FormulateInput>
			<hr>
			<FormulateInput type="switchradio" label="test-label" :options="{one: 'One', two: 'Two'}"></FormulateInput>
			<hr>
			<FormulateInput type="borderbox" label="test-label"></FormulateInput>
			<hr>
			<FormulateInput type="borderbox" label="test-label" :options="{one: 'One', two: 'Two'}"></FormulateInput>
			<hr>
			<FormulateInput type="borderradio" label="test-label"></FormulateInput>
			<hr>
			<FormulateInput type="borderradio" label="test-label" :options="{one: 'One', two: 'Two'}"></FormulateInput>
			<hr>
		</FormulateForm>
	</div>
</template>

<script>
export default {
    name: "FormulateInputs",
    data() {
    	return {
    		form: {},
            form2: {},
            form3: {},
            form4: {
                id: {
                    id_number: '123'
                },
                id2: '{"id_number": 123}'
            },
            schema: [
                {
                    type: 'image',
                    name: 'password',
                    label: 'Enter a new password',
                    help: 'Test help'
                },
                {
                    type: 'image',
                    name: 'password2',
                    label: 'Enter a new password',
                    help: 'Test help'
                },
                {
                    type: 'submit',
                    label: 'Change password'
                }
            ]
        };
    },
    methods: {
        submit(data) {
            console.log(data);
        }
    }
}
</script>

<style scoped>

</style>